import { ref, uploadBytesResumable, getDownloadURL } from 'firebase/storage';
import { storage } from '../firebase/config';

/**
 * Lädt eine Datei in Firebase Storage hoch
 * @param {File} file - Die hochzuladende Datei
 * @param {string} path - Der Pfad im Storage (z.B. 'drivers/avatars')
 * @param {function} progressCallback - Callback-Funktion, die den Upload-Fortschritt empfängt (0-100)
 * @returns {Promise<string>} - Promise, der die Download-URL der hochgeladenen Datei zurückgibt
 */
export const uploadFile = async (file, path, progressCallback = null) => {
  return new Promise((resolve, reject) => {
    // Eindeutigen Dateinamen generieren, um Überschreibungen zu vermeiden
    const timestamp = new Date().getTime();
    const fileName = `${timestamp}_${file.name}`;
    const storageRef = ref(storage, `${path}/${fileName}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        // Upload-Fortschritt überwachen
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        if (progressCallback) {
          progressCallback(progress);
        }
      },
      (error) => {
        // Fehlerbehandlung
        console.error('Upload fehlgeschlagen:', error);
        reject(error);
      },
      async () => {
        // Upload abgeschlossen
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        resolve(downloadURL);
      }
    );
  });
};

/**
 * Lädt ein Profilbild für einen Fahrer hoch
 * @param {File} file - Die Bilddatei
 * @param {string} driverId - Die ID des Fahrers
 * @param {function} progressCallback - Callback-Funktion für den Fortschritt
 * @returns {Promise<string>} - Promise, der die Download-URL zurückgibt
 */
export const uploadDriverProfilePicture = (file, driverId, progressCallback = null) => {
  return uploadFile(file, `drivers/profiles/${driverId}`, progressCallback);
};